// inspired by vuetify breakpoint service
// https://github.com/vuetifyjs/vuetify/blob/master/packages/vuetify/src/services/breakpoint/index.ts
import Vue from 'vue';
import { Plugin } from '@nuxt/types';

class Breakpoint {
  thresholds = {
    sm: 768,
    md: 992,
    lg: 1280,
    xl: 1600,
  };

  state = new Vue({
    name: 'Breakpoint',
    data() {
      return { name: 'xl' };
    },
  });

  resizeTimeout: number | undefined = undefined;

  constructor() {
    this.init();
  }

  get name() {
    return this.state.name;
  }

  get smAndUp() {
    return this.name !== 'xs';
  }

  get mdAndUp() {
    return !['xs', 'sm'].includes(this.name);
  }

  init() {
    if (typeof window === 'undefined') return;

    window.addEventListener('load', () => {
      window.addEventListener('resize', this.onResize.bind(this), { passive: true });
      this.update();
    });
  }

  onResize() {
    clearTimeout(this.resizeTimeout);

    this.resizeTimeout = window.setTimeout(this.update.bind(this), 200);
  }

  update() {
    const width = this.getClientWidth();

    const xs = width < this.thresholds.sm;
    const sm = width < this.thresholds.md && !xs;
    const md = width < this.thresholds.lg && !(sm || xs);
    const lg = width < this.thresholds.xl && !(md || sm || xs);

    switch (true) {
      case xs:
        this.state.name = 'xs';
        break;
      case sm:
        this.state.name = 'sm';
        break;
      case md:
        this.state.name = 'md';
        break;
      case lg:
        this.state.name = 'lg';
        break;
      default:
        this.state.name = 'xl';
        break;
    }
  }

  getClientWidth() {
    if (typeof document === 'undefined') return 0;

    return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  }
}

const breakpointPlugin: Plugin = (context, inject) => {
  inject('breakpoint', new Breakpoint());
};

export default breakpointPlugin;
